module.exports = __webpack_public_path__ + "assets/img/chronicleImg-06de06b7.png";